import {
  dataTableOnlySelectedViewModes,
  type DataTableOnlySelectedViewMode,
} from "@/types/dataTableSettings";
import { create } from "zustand";

export type AllocationsListView = DataTableOnlySelectedViewMode;

interface AllocationsListViewState {
  view: AllocationsListView;
  setView: (view: AllocationsListView) => void;
}

export const useAllocationsListViewStore = create<AllocationsListViewState>(
  (set) => ({
    view: dataTableOnlySelectedViewModes.all,
    setView: (view) => set({ view }),
  }),
);
